import React from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  IconAddInCircle16,
  IconRemoveInCircle16,
  Inline,
  Text,
} from '@stitch-fix/mode-react';

const QuantitySelector = ({
  quantity,
  increment,
  decrement,
  quantityAvailable,
}) => {
  return (
    <Inline spacing={{ sm: 0, md: 0.25 }} vAlign="center">
      <Text height="short" family="regular" scale="2" color="gray-35">
        Qty:
      </Text>
      <IconButton
        aria-label="Decrease quantity"
        onClick={decrement}
        type="button"
        id="decrement-button"
        data-testid="decrement-button"
      >
        <IconRemoveInCircle16 />
      </IconButton>
      <Text height="short" family="medium" scale="2" data-testid="quantity">
        {quantity}
      </Text>
      <IconButton
        aria-label="Increase quantity"
        onClick={increment}
        type="button"
        id="increment-button"
        data-testid="increment-button"
        disabled={quantity >= quantityAvailable}
      >
        <IconAddInCircle16 />
      </IconButton>
    </Inline>
  );
};

QuantitySelector.propTypes = {
  quantity: PropTypes.number.isRequired,
  decrement: PropTypes.func.isRequired,
  increment: PropTypes.func.isRequired,
  quantityAvailable: PropTypes.number.isRequired,
};

export default QuantitySelector;
